import React from 'react';
import { hexToRGBA, PILL_COLORS } from '@/components/ui/Pill/Pills.utils';
import clsx from 'clsx';

type PillProps = {
  children?: React.ReactNode;
  // White background with a colored border + text — for passive/aggregate labels
  // (e.g. rolled-up counts) that should read as informational, not filled/actionable.
  outline?: boolean;
  pillColor: string | 'red' | 'yellow' | 'green' | 'purple' | 'grey';
  pillClassName?: string;
  solid?: boolean;
};

const Pill = ({
  children,
  outline = false,
  pillColor,
  pillClassName,
  solid = false,
} : PillProps) => {
  const resolvedColor = PILL_COLORS[pillColor] || pillColor;

  let backgroundColor = hexToRGBA(resolvedColor, 0.1);
  let textColor = hexToRGBA(resolvedColor);
  let border;

  if (outline) {
    backgroundColor = '#ffffff';
    border = `1px solid ${hexToRGBA(resolvedColor, 0.3)}`;
  } else if (solid) {
    backgroundColor = resolvedColor;
    textColor = '#ffffff';
  }

  return (
    <div
      className={clsx('tw-w-fit tw-px-2 tw-py-1 tw-rounded-full',
        'tw-flex tw-items-center tw-justify-center',
        pillClassName)}
      style={{
        backgroundColor,
        border,
        color: textColor,
      }}
    >
      {children}
    </div>
  );
};

export default Pill;
